import React, { useState } from "react";
import { logoColor } from "../../../constant/imagePath";
import { MobileFooter } from "../../../stories/MobileFooter/MobileFooter";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader";
import classes from "./SettingsMobile.module.css";
import { Tabs } from "../../../stories/Tabs/Tabs";
import { Col, Container, Row } from "react-bootstrap";
import Fonts from "../../../stories/assets/Fonts";
import Colors from "../../../stories/assets/Colors";
import PersonalInfo from "./PersonalInfo/PersonalInfo";
import PayoutMethod from "./PayoutMethod/PayoutMethod";
import Notifications from "./Notifications/Notifications";

const SettingsMobile = () => {
  const [activeTab, setActiveTab] = useState({ label: "Personal Info" });
  const tabsData = [
    { label: "Personal Info" },
    { label: "Payment methods" },
    { label: "Notifications" },
  ];
  return (
    <div>
      <MobileHeader
        isLogo={true}
        logo={logoColor}
        customStyle={{ marginBottom: "24px", padding: "16px" }}
      />
      <div className={[classes.SettingsMobileScreen]}>
        <h2
          style={{
            color: Colors.neutralShadesOfNero,
            ...Fonts.h2,
            fontSize: "26px",
            lineHeight: "32px",
          }}
          className={[classes.heading]}
        >
          Account settings
        </h2>
        <div className={[classes.tabsDiv]}>
          <Tabs state={activeTab} setState={setActiveTab} tabsData={tabsData} />
        </div>

        {activeTab.label === "Personal Info" && <PersonalInfo />}
        {activeTab.label === "Payment methods" && <PayoutMethod />}
        {activeTab.label === "Notifications" && <Notifications />}
      </div>

      <MobileFooter />
    </div>
  );
};

export default SettingsMobile;
